export const formatSignatureData = (imageData: string): string => {
    return imageData.startsWith('data:') ? imageData : imageData.startsWith('image') ? `data:${imageData}` : imageData;
};

export const unformatSignatureData = (imageData: string): string => {
    return imageData.startsWith('data:') ? imageData.replace(/^data:/, '') : imageData;
};
